<template>
  <div class="mobile-query-order">
    <!-- 时间选择区域 -->
    <div class="time-picker-wrapper">
      <div class="time-input-group">
        <label>开始时间:</label>
        <input type="datetime-local" v-model="startTime" class="full-width">
      </div>
      <div class="time-input-group">
        <label>结束时间:</label>
        <input type="datetime-local" v-model="endTime" class="full-width">
      </div>
      <!-- 新增 IP 输入框 -->
      <div class="time-input-group">
        <label>IP:</label>
        <input type="text" v-model="ip" class="full-width" placeholder="请输入 IP 地址">
      </div>
      <div class="button-group">
        <button @click="setDateRange('today')" class="action-btn">今天</button>
        <button @click="setDateRange('yesterday')" class="action-btn">昨天</button>
        <button @click="setDateRange('dayBeforeYesterday')" class="action-btn">前天</button>
      </div>
      <div class="button-group">
        <button @click="queryOrders(1)" class="action-btn query-btn">已完成</button>
        <button @click="queryOrders(0)" class="action-btn all-btn">全部</button>
        <button @click="copyOrderData" class="action-btn copy-btn">复制</button>
      </div>
    </div>

    <!-- 订单列表展示 -->
    <div class="order-list-mobile">
      <!-- 新增当前可充金额展示 -->
      <div class="total-amount">当前可充: {{ CanRechage }}</div>
      <div class="total-amount">已充合计: {{ totalAmount }}</div>
      
      <div class="order-card" v-for="order in orderList" :key="order.id">
        <div class="order-row">
          <span class="label">ID:</span>
          <span class="value">{{ order.id }}</span>
        </div>
        <div class="order-row">
          <span class="label">金额:</span>
          <span class="value">{{ order.payMonery }}</span>
        </div>
        <div class="order-row">
          <span class="label">Ip:</span>
          <span class="value copyable-text" ref="ipText">{{ order.ip }}</span>
          <button class="copy-ip-btn" @click="copyIp(order.ip)">复制</button>
        </div>
        <div class="order-row">
          <span class="label">创建时间:</span>
          <span class="value">{{ order.createdTime }}</span>
        </div>
        <div class="order-row">
          <span class="label">备注:</span>
          <span class="value">{{ order.summary }}</span>
          <span 
            class="value status-value" 
            :class="{ 'completed-status': order.status === '已完成' }" 
            style="margin-left: 10px;"
          >
            状态: {{ order.status }}
          </span>
        </div>
        <div class="order-row">
          <span class="label">地区:</span>
          <span class="value">{{ order.area }}</span>
        </div>
      </div>
    </div>
    <!-- 新增错误提示 -->
    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startTime: '',
      endTime: '',
      orderList: [],
      token: '',
      ip: '',
      timestamp: 0,
      totalAmount: 0,
      isKJ: false,
      errorMessage: '',
      // 新增当前可充金额变量
      CanRechage: '0' 
    };
  },
  mounted() {
    this.getTokenAndTimestamp();
  },
  methods: {
    getTokenAndTimestamp() {
      this.token = 'your_token';
      this.timestamp = Date.now();
    },
    // 新增快速选择时间方法
    setDateRange(type) {
      const now = new Date();
      let start, end;

      switch(type) {
        case 'today':
          // 在原日期基础上增加 8 小时（8 * 60 * 60 * 1000 毫秒）
          start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
          start.setTime(start.getTime() + 8 * 60 * 60 * 1000);
          end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
          end.setTime(end.getTime() + 8 * 60 * 60 * 1000);
          this.isKJ = true;
          break;
        case 'yesterday':
          // 在原日期基础上增加 8 小时（8 * 60 * 60 * 1000 毫秒）
          start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
          start.setTime(start.getTime() + 8 * 60 * 60 * 1000);
          end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
          end.setTime(end.getTime() + 8 * 60 * 60 * 1000);
          this.isKJ = true;
          break;
        case 'dayBeforeYesterday':
          // 在原日期基础上增加 8 小时（8 * 60 * 60 * 1000 毫秒）
          start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 2);
          start.setTime(start.getTime() + 8 * 60 * 60 * 1000);
          end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
          end.setTime(end.getTime() + 8 * 60 * 60 * 1000);
          break;
      }

      // 转换为 ISO 字符串并截取日期时间部分
      this.startTime = start.toISOString().slice(0, 16);
      this.endTime = end.toISOString().slice(0, 16);
      this.queryOrders(1); // 自动触发查询，默认查询状态为 0
    },
    async queryOrders(status = 0) {
      // 清理前一次的查询结果
      this.orderList = [];
      this.totalAmount = 0;
      this.CanRechage = ''; // 清空可充金额

      const urlParams = new URLSearchParams(this.$route.query);
      const channelId = parseInt(urlParams.get('channelId')) || 0;
      const gameid = parseInt(urlParams.get('gameid')) || 0;

      // 转换为北京时间
      const formattedStartTime = this.convertToBeijingTime(this.startTime);
      const formattedEndTime = this.convertToBeijingTime(this.endTime);

      const requestData = {
        channelId,
        startTime: formattedStartTime,
        endTime: formattedEndTime,
        token: this.token,
        gameid,
        ip: this.ip,
        timestamp: this.timestamp,
        status
      };

      try {
        // 获取当前可充金额
        //const rechargeResponse = await fetch('http://localhost:5053/api2/ProduceIdCanRecharge?ProduceId=2');
        //const rechargeResponse = await fetch('https://page.sverta.makeup/api2/ProduceIdCanRecharge?ProduceId=${gameid}');
        const rechargeResponse = await fetch(`${window.location.origin}/api2/ProduceIdCanRecharge?ProduceId=${gameid}`);
        const rechargeData = await rechargeResponse.json();
        if (rechargeData.code === 1) {
          this.CanRechage = rechargeData.data;
        } else {
          this.errorMessage = rechargeData.message || '获取可充金额失败';
          console.error('获取可充金额失败:', this.errorMessage);
          return;
        }
        // const response = await fetch('http://localhost:5053/api2/QueryOrderByStatus', {
        //const response = await fetch('https://page.sverta.makeup/api2/QueryOrderByStatus', {
        const response = await fetch(`${window.location.origin}/api2/QueryOrderByStatus`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestData)
        });

        const data = await response.json();
        if (data.code === 1) {
          this.orderList = data.list;
          // 只累加状态等于已完成的记录的 order.payMonery
          this.totalAmount = this.orderList.reduce((sum, order) => {
            if (order.status === '已完成') {
              return sum + (parseFloat(order.payMonery) || 0);
            }
            return sum;
          }, 0);
          // 清空错误信息
          this.errorMessage = ''; 
        } else {
          if (data.message === '') {
            this.errorMessage = '没有数据';
          } else {
            this.errorMessage = data.message;
          }
          console.error('查询订单失败:', this.errorMessage);
        }
      } catch (error) {
        this.errorMessage = '请求出错: ' + error.message;
        console.error('请求出错:', error);
      }
    },
    // 修正后的转换为北京时间的方法
    convertToBeijingTime(dateString) {
      if (!dateString) return '';
      // 创建一个新的 Date 对象
      const localDate = new Date(dateString);
      // 获取本地时间戳
      const localTimestamp = localDate.getTime();
      // 计算本地时区偏移量（分钟）
      const localOffset = localDate.getTimezoneOffset();
      // 北京时间偏移量（东八区，480 分钟）
      const beijingOffset = 480;
      // 计算北京时间的时间戳
      const beijingTimestamp = localTimestamp + (localOffset + beijingOffset+ beijingOffset ) * 60 * 1000;
      // 创建北京时间的 Date 对象
      const beijingDate = new Date(beijingTimestamp);
      // 格式化为 ISO 字符串
      return beijingDate.toISOString();
    },
    copyOrderData() {
      const data = this.orderList.map(order => 
        `ID: ${order.id}\t金额: ${order.payMonery}\t渠道: ${order.payChannel}\t创建时间: ${order.createdTime}\t备注: ${order.summary}`
      ).join('\n');
      navigator.clipboard.writeText(data);
      alert('数据已复制到剪贴板');
    },
    copyIp(ip) {
      navigator.clipboard.writeText(ip).then(() => {
        alert('IP 已复制到剪贴板');
      }).catch((err) => {
        console.error('复制失败:', err);
        this.errorMessage = '复制失败: ' + err.message;
      });
    }
  }
};
</script>

<style scoped>
.mobile-query-order {
  padding: 1rem;
  max-width: 100%;
  box-sizing: border-box;
}

.time-picker-wrapper {
  background: #f5f5f5;
  padding: 1rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
}

.time-input-group {
  margin-bottom: 1rem;
}

.time-input-group label {
  display: block;
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.full-width {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
}

.button-group {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  flex-wrap: wrap; /* 允许按钮换行 */
}

.action-btn {
  flex: 1;
  min-width: 100px; /* 设置最小宽度 */
  padding: 1rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
}

.query-btn {
  background: #007bff;
  color: white;
}

.copy-btn {
  background: #28a745;
  color: white;
}

.order-list-mobile {
  background: white;
  border-radius: 12px;
  padding: 1rem;
}

.total-amount {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
}

.order-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.order-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.order-row .label {
  color: #666;
  min-width: 60px;
}

.order-row .value {
  color: #333;
  text-align: right;
  flex: 1;
}

.status-value {
  font-weight: bold; /* 加粗字体 */
}

.completed-status {
  color: #b13813; /* 已完成状态使用绿色，可根据需求修改 */
}

.status-value:not(.completed-status) {
  color: #5b6568; /* 其他状态使用橙色，可根据需求修改 */
}
@media (max-width: 480px) {
  .mobile-query-order {
    padding: 0.5rem;
  }
  
  .action-btn {
    padding: 0.8rem;
    font-size: 0.9rem;
  }
}

/* 新增错误提示样式 */
.error-message {
  color: #ff4444;
  background-color: #ffebee;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  text-align: center;
}

.copyable-text {
  user-select: text; /* 允许文本被选择 */
  cursor: text; /* 鼠标悬停显示文本选择光标 */
}

.copy-ip-btn {
  margin-left: 10px;
  padding: 2px 8px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
}

.copy-ip-btn:hover {
  background-color: #0056b3;
}
.all-btn {
  background: #6c757d;
  color: white;
}
</style>